import { defineComponent, computed, createBlock, openBlock, resolveDynamicComponent, normalizeProps, guardReactiveProps, withCtx, renderSlot, createTextVNode, toDisplayString } from "vue";
import { asLinkAttrs } from "@prismicio/client";
import { isInternalURL } from "./lib/isInternalURL.js";
import { usePrismic } from "./usePrismic.js";
const defaultInternalComponent = "router-link";
const defaultExternalComponent = "a";
const defaultExternalRelAttribute = "noreferrer";
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{ name: "PrismicLink" },
  __name: "PrismicLink",
  props: {
    linkResolver: {},
    rel: { type: [String, Function] },
    internalComponent: {},
    externalComponent: {},
    field: {},
    document: {}
  },
  setup(__props) {
    const props = __props;
    const { options } = usePrismic();
    const rawAttrs = computed(() => {
      return asLinkAttrs(props.field || props.document, {
        linkResolver: props.linkResolver || options.linkResolver,
        rel(args) {
          var _a;
          const maybeRel = props.rel || ((_a = options.components) == null ? void 0 : _a.linkRel);
          if (maybeRel) {
            return typeof maybeRel === "function" ? maybeRel(args) : maybeRel;
          }
          return args.isExternal ? defaultExternalRelAttribute : void 0;
        }
      });
    });
    const component = computed(() => {
      var _a, _b;
      return isInternalURL(rawAttrs.value.href || "") ? props.internalComponent || ((_a = options.components) == null ? void 0 : _a.linkInternalComponent) || defaultInternalComponent : props.externalComponent || ((_b = options.components) == null ? void 0 : _b.linkExternalComponent) || defaultExternalComponent;
    });
    const attrs = computed(() => {
      return component.value === "a" ? {
        href: rawAttrs.value.href,
        target: rawAttrs.value.target,
        rel: rawAttrs.value.rel
      } : {
        to: rawAttrs.value.href,
        target: rawAttrs.value.target,
        rel: rawAttrs.value.rel
      };
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(component.value), normalizeProps(guardReactiveProps(attrs.value)), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default", {}, () => [
            createTextVNode(toDisplayString(props.field && "text" in props.field ? props.field.text : void 0), 1)
          ])
        ]),
        _: 3
      }, 16);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=PrismicLink.vue.js.map
